import styled, { css } from 'styled-components';
import { Link } from '../../../../../../../common/components/Link';
import { ThemeColours } from '../../../../../../../common/styles/ThemeColours';
import {
  Breakpoint,
  FontSize,
  FontWeight,
  PRESSABLE,
  PRESSABLE_LINK,
} from '../../../../../../../common/styles/constants';

export const NextAvailableView = styled.div`
  align-items: flex-start;
  color: ${ThemeColours.mono700};
  display: flex;
  flex-grow: 1;
  font-weight: ${FontWeight.SEMI_BOLD};
  line-height: 1.15em;
  margin: 4px 0 4px 8px;

  ${Breakpoint.SMALL} {
    font-size: 14px;
  }

  ${Breakpoint.MEDIUM} {
    align-items: center;
    flex-direction: row;
    margin: 4px 0 4px 24px;
  }
`;

export const Label = styled.div`
  color: ${ThemeColours.mono700};
  font-size: 12px;
  font-weight: ${FontWeight.REGULAR};
  padding-right: 8px;
  margin-left: 10px;

  ${Breakpoint.MEDIUM} {
    margin-left: 0;
  }
}
`;

export const Meat = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
`;

export const DateLink = styled(Link)`
  ${PRESSABLE_LINK};
  color: ${ThemeColours.primary};
  display: block;
  font-size: ${FontSize.SMALL};
  font-weight: ${FontWeight.SEMI_BOLD};
  margin-inline-end: 8px;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

export const LastOneLink = styled(Link)`
  ${PRESSABLE};
  background-color: ${ThemeColours.negative};
  border-radius: 8px;
  color: ${ThemeColours.white};
  display: block;
  flex-shrink: 0;
  font-size: 12px;
  font-weight: ${FontWeight.BOLD};
  line-height: 1em;
  min-width: 40px;
  padding: 2px 8px;
  text-align: center;
  text-decoration: none;
`;

const moreLinkStyle = css`
  ${PRESSABLE};
  background-color: ${ThemeColours.mono200};
  border-radius: 8px;
  color: ${ThemeColours.mono700};
  display: block;
  flex-shrink: 0;
  font-size: 12px;
  font-weight: ${FontWeight.BOLD};
  line-height: 1em;
  padding: 2px 8px;
  text-decoration: none;
`;

export const MoreLink = styled(Link)`
  ${moreLinkStyle}
`;

export const MoreSpan = styled.span`
  ${moreLinkStyle}
`;
